import Vue from 'vue'
import Router from 'vue-router'
import WhatsOn from './views/WhatsOn'
import Resource from './views/Resource'
import ResourceDetail from './views/ResourceDetail'
import ResourceSearch from './views/ResourceSearch'
import ResourceTags from './views/ResourceTags'
import WhatsOnDetail from './views/WhatsOnDetail'
import WhatsOnSearch from './views/WhatsOnSearch'

/* Code splitting */
const Education = () => import(/* webpackChunkName: "education" */ './views/education/Education')
const EducationBundle = () => import(/* webpackChunkName: "education" */ './views/education/EducationBundle')
const EducationModule = () => import(/* webpackChunkName: "education" */ './views/education/EducationModule')
const EducationHome = () => import(/* webpackChunkName: "education" */ './views/education/EducationHome')
const EducationProgrammeSearch = () => import(/* webpackChunkName: "education" */ './views/education/EducationProgrammeSearch')
const EducationProgramme = () => import(/* webpackChunkName: "education" */ './views/education/EducationProgramme')

const OMPAEntryForm = () => import(/* webpackChunkName: "ompa" */ './views/ompa/OMPAEntryForm')

const MatarikiPage = () => import(/* webpackChunkName: "matariki" */ './views/matariki/MatarikiPage')
const MatarikiSubmission = () => import(/* webpackChunkName: "matariki" */ './views/matariki/MatarikiSubmissionForm')
const MatarikiHome = () => import(/* webpackChunkName: "matariki" */ './views/matariki/MatarikiHome')
const MatarikiSchedule = () => import(/* webpackChunkName: "matariki" */ './views/matariki/MatarikiSchedule')
const MatarikiThanks = () => import(/* webpackChunkName: "matariki" */ './views/matariki/MatarikiThanks')

const DBugEntry = () => import(/* webpackChunkName: "dbug" */ './views/DBugEntry');
const DCCSubmission = () => import(/* webpackChunkName: "dcc" */ './views/DCCSubmission')

import MysteryVisitor from './views/MysteryVisitor'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/whats-on',
      component: WhatsOn,
      children: [
        {
          path: '',
          name: 'whatsonsearch',
          component: WhatsOnSearch,
          props: (route) => ({ query: route.query })
        },
        {
          path: ':slug',
          name: 'whatsondetail',
          component: WhatsOnDetail,
          props: true
        }
      ]
    },
    {
      path: '/athome',
      component: Resource,
      children: [
        {
          path: '',
          name: 'resourcesearch',
          component: ResourceSearch,
          props: (route) => ({ query: route.query })
        },
        {
          name: 'topics',
          path: 'topics',
          component: ResourceTags
        },
        {
          path: ':slug',
          name: 'resourcedetail',
          component: ResourceDetail,
          props: true
        }
      ]
    },
    {
      path: '/education',
      component: Education,
      children: [
        {
          path: '',
          name: 'educationhome',
          component: EducationHome
        },
        {
          path: 'bundle/:slug',
          name: 'educationbundle',
          component: EducationBundle,
          props: true
        },
        {
          path: 'module/:slug',
          name: 'educationmodule',
          component: EducationModule,
          props: true
        },
        {
          path: 'programmes',
          name: 'educationprogrammes',
          component: EducationProgrammeSearch,
          props: true
        },
        {
          path: 'programme/:slug',
          name: 'educationprogramme',
          component: EducationProgramme,
          props: true
        },

      ]
    },
    {
      path: '/submission',
      name: 'submission',
      component: DCCSubmission,
    },
    {
      path: '*', 
      redirect: '/'
    },
    { 
      path: '/mystery-visitor',
      name: 'mysteryvisitor',
      component: MysteryVisitor
    },
    {
      path: '/d-bug-game-design-challenge/entry-form',
      name: 'dbug',
      component: DBugEntry
    },
    {
      path: '/photo/entry/:token?',
      name: 'ompaentry',
      component: OMPAEntryForm,
      props: true
    },
    {
      path: '/matariki',
      component: MatarikiPage,
      children: [
        {
          path: '',
          name: 'matariki',
          component: MatarikiHome,
        },
        {
          path: 'submission',
          name: 'matarikisubmission',
          component: MatarikiSubmission,
        },
        {
          path: 'thanks',
          name: 'matarikithanks',
          component: MatarikiThanks,
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
